import { Fragment } from "react";
import { FieldColumnName } from "../../fields/FieldColumnName";
import { PanelProps } from "../ModalCreateColumn";
import { FieldDefaultFormulaChoice } from "../../fields/FieldDefaultFormulaChoice";
import { FieldChoices } from "../../fields/FieldChoices";

export const PanelCreateColumnChoice = ({
  autoFocus = true,
  isDefinitionEditable = true,
  fields,
  onFieldChange,
}: PanelProps) => {
  return (
    <Fragment>
      <FieldColumnName
        autoFocus={autoFocus}
        value={fields.name.value}
        onChange={(field) => {
          onFieldChange("name", {
            value: field.value,
            isValid: field.isValid,
            isDirty: true,
          });
        }}
      />

      <FieldChoices
        disabled={!isDefinitionEditable}
        value={
          fields.definition.value?.kind === "choice"
            ? fields.definition.value.choices
            : []
        }
        onChange={(choices) => {
          const uniqValues = new Set(choices.map((choice) => choice.value));
          onFieldChange("definition", {
            value: {
              kind: "choice",
              choices,
            },
            isValid:
              uniqValues.size > 0 &&
              uniqValues.size === choices.length &&
              choices.every(
                (choice) => choice.label !== "" && choice.value !== "",
              ),
          });
        }}
      />

      <FieldDefaultFormulaChoice
        disabled={!fields.definition.isValid}
        choices={
          fields.definition.value?.kind === "choice"
            ? fields.definition.value.choices
            : []
        }
        value={fields.default_formula.value}
        onChange={(field) => {
          onFieldChange("default_formula", {
            value: field.value,
            isValid: field.isValid,
          });
        }}
      />
    </Fragment>
  );
};
